/* Existing package photos, matched by exact variant ID. No purchase logic. */
(function () {
  'use strict';
  if (window.__hlPackagePhotosInstalled) return;
  window.__hlPackagePhotosInstalled = true;

  function enhancePackagePhotos(root) {
    var library = document.getElementById('HampsteadPackagePhotoTemplates');
    if (!library || !library.content) return;
    var byVariant = Object.create(null);
    library.content.querySelectorAll('template[data-hl-package-variants]').forEach(function (template) {
      template.getAttribute('data-hl-package-variants').split(',').forEach(function (id) {
        if (id.trim()) byVariant[id.trim()] = template;
      });
    });
    var cards = (root || document).querySelectorAll('.antiiva-master [data-master-offer-card]');
    cards.forEach(function (card) {
      var section = card.closest('.antiiva-master');
      // The already-approved Classic composition is the reference, not a repair target.
      if (!section || section.classList.contains('antiiva-master--original')) return;
      var slot = card.querySelector('[data-master-offer-image]');
      var select = card.querySelector('[data-master-offer][data-variant-id]');
      if (!slot || !select || slot.hasAttribute('data-hl-package-photo')) return;
      var template = byVariant[select.getAttribute('data-variant-id')];
      var source = template && template.content.querySelector('img');
      if (!source) return; // Retain the original when no exact product photo exists.
      var image = source.cloneNode(true);
      var heading = card.querySelector('h3');
      if (heading) image.alt = source.alt + ' — ' + heading.textContent.trim();
      image.decoding = 'async';
      var previous = Array.from(slot.childNodes);
      slot.setAttribute('data-hl-package-photo', template.getAttribute('data-hl-product-handle'));
      slot.classList.add('hl-package-photo-slot');
      image.addEventListener('error', function () {
        // Restore the original nodes if this photo cannot load. The button is never replaced.
        if (image.parentNode !== slot) return;
        slot.replaceChildren.apply(slot, previous);
        slot.classList.remove('hl-package-photo-slot');
        slot.setAttribute('data-hl-package-photo', 'fallback');
      }, { once: true });
      slot.replaceChildren(image);
    });
  }

  function ready() { enhancePackagePhotos(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
  document.addEventListener('shopify:section:load', function (event) { enhancePackagePhotos(event.target); });
})();
